var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React, { isValidElement } from 'react';
import reactCSS from 'reactcss';
import * as checkboard from '../../helpers/checkboard';
export var Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
    grey = _ref.grey,
    size = _ref.size,
    renderers = _ref.renderers,
    borderRadius = _ref.borderRadius,
    boxShadow = _ref.boxShadow,
    children = _ref.children;
  var styles = reactCSS({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return /*#__PURE__*/ /*#__PURE__*/isValidElement(children) ? /*#__PURE__*/React.cloneElement(children, _extends({}, children.props, {
    style: _extends({}, children.props.style, styles.grid)
  })) : /*#__PURE__*/React.createElement('div', {
    style: styles.grid
  });
};
Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};
export default Checkboard;